import { useEffect,  useState } from 'react';
import {  useParams } from 'react-router-dom';
import siteApi from 'api/siteApi';
import { MESSAGE } from 'constants';


export const useSiteDetails = () => {
    const { id: siteID } = useParams();
    const [siteDetails, setSiteDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        title: '',
        type: '',
        contents: []
    });
   
    useEffect(() => {
        (async function getSiteDetails() {
            if(!siteID) return;
        
            try {
                setIsLoading(true);
                /**Call Api */
                const params = {
                    id: siteID,
                }
                const dtRes = await siteApi.getDetails(params);
                setSiteDetails(dtRes.data || {});
                setIsLoading(false);

            } catch (err) {
                console.log('err', err);
                setIsLoading(false);
                const errMsg = {
                    type: MESSAGE.ERROR,
                    contents: [err]
                }
                setMessage(errMsg);
            }
        })();
        return;
    }, [siteID]);

    return { siteDetails, isLoading, message, setMessage };
}